import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Session from '../../../../api/session';
import Title from '../../../components/Title';
import Navbar from '../../../../layout/logged_in/Navbar';
import Sidenav from '../../../../layout/logged_in/Sidenav';
import Button from '../../../components/Button';
import Modal from '../../../components/Modal';
import Loading from '../../../components/Loading';
import generateRandomKey from '../../../components/GenerateRandomKey';
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import SlugInput from '../../../components/SlugInput';
import { frontendUrl, backendUrl, staticUrl } from '../../../../config';

const FabricsAdmin = () => {

    const translate = {
        generic: 'Generic Information',
        details: 'Details',
    };

    // Collection & Performance
    const [collection, setCollection] = useState([ { name: 'Stocked Fabrics', value: 1 }, { name: 'Special Order Fabrics', value: 2 } ]);
    const [performance, setPerformance] = useState([ { name: 'Standard Performance', value: 1 }, { name: 'High Performance', value: 2 } ]);
    const [collectionID, setCollectionID] = useState('');
    const [performanceID, setPerformanceID] = useState('');
    const collectionRef = useRef(null);
    const performanceRef = useRef(null);

    // Product information
    const [collectionName, setCollectionName] = useState('');
    const [collectionId, setCollectionId] = useState(0);
    const [care1Id, setCare1Id] = useState(0);
    const [care2Id, setCare2Id] = useState(0);
    const [care3Id, setCare3Id] = useState(0);
    const [care4Id, setCare4Id] = useState(0);
    const [care5Id, setCare5Id] = useState(0);
    const [productName, setProductName] = useState('');
    const [productCode, setProductCode] = useState('');
    const [productGrade, setProductGrade] = useState('');
    const [colorInformation, setColorInformation] = useState('');
    const [fabricInformation, setFabricInformation] = useState('');
    const [colors, setColors] = useState([]);
    const [images, setImages] = useState([]);
    const [fabrics, setFabrics] = useState([]);
    const [collections, setCollections] = useState([]);
    const [carePDFs, setCarePDFs] = useState([]);

    // Active / New
    const [newCheckboxValue, setNewCheckboxValue] = useState(false);
    const [activeCheckboxValue, setActiveCheckboxValue] = useState(false);

    const productNameRef = useRef(null);
    const productCodeRef = useRef(null);
    const productGradeRef = useRef(null);
    const collectionIdRef = useRef(null);
    const careId1Ref = useRef(null);
    const careId2Ref = useRef(null);
    const careId3Ref = useRef(null);
    const careId4Ref = useRef(null);
    const careId5Ref = useRef(null);

    // Slug
    const [slugValue, setSlugValue] = useState('');
    const slugInputRef = useRef(null);

    // SEO Fields
    const [titleTag, setTitleTag] = useState('');
    const [metaDescription, setMetaDescription] = useState('');
    const titleTagRef = useRef(null);
    const metaDescriptionRef = useRef(null);
  
    // Loading
    const [isLoading, setIsLoading] = useState(true);

    // Show product does not exist
    const [isError, setIsError] = useState(false);

    // API call to get product section data
    const { productId, sectionId } = useParams();
    const [data, setData] = useState([]);
    const [expandedChecked, setExpandedChecked] = useState('');

    // Standard
    const standardShownRef = useRef(null);
    const standardCushionsRef = useRef(null);
    const standardUmbrellasRef = useRef(null);
    const standardBrandRef = useRef(null);
    const standardRepeatRef = useRef(null);
    const standardSelvedgeRef = useRef(null);
    const standardRollRef = useRef(null);
    const standardContentRef = useRef(null);
    const standardPerformanceRef = useRef(null);
    const standardFlammabilityRef = useRef(null);
    const standardDoubleRubsRef = useRef(null);

    const [standardShown, setStandardShown] = useState('');
    const [standardCushions, setStandardCushions] = useState('');
    const [standardUmbrellas, setStandardUmbrellas] = useState('');
    const [standardBrand, setStandardBrand] = useState('');
    const [standardRepeat, setStandardRepeat] = useState('');
    const [standardSelvedge, setStandardSelvedge] = useState('');
    const [standardRoll, setStandardRoll] = useState('');
    const [standardContent, setStandardContent] = useState('');
    const [standardPerformance, setStandardPerformance] = useState('');
    const [standardFlammability, setStandardFlammability] = useState('');
    const [standardDoubleRubs, setStandardDoubleRubs] = useState('');

    const modalAddCellLeft = useRef(null);
    const modalAddCellRight = useRef(null);
    const modalEditCellLeft = useRef(null);
    const modalEditCellRight = useRef(null);


    // Start of Filters
    const [filterGroups, setFilterGroups] = useState([]);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState({});

    const handleCheckboxChange = (name) => {
        setSelectedCheckboxes({ ...selectedCheckboxes, [name]: !selectedCheckboxes[name] });
        console.log(selectedCheckboxes)
        // Send update to backend
        // axios.post('/api/updateSelectedCheckboxes', { productId, name }); // Send productId and checkbox name to update
    };

    // Function to group filter items by group_name
    const groupedFilterGroups = filterGroups.reduce((acc, curr) => {
        if (!acc[curr.group_name]) {
        acc[curr.group_name] = [];
        }
        acc[curr.group_name].push(curr);
        return acc;
    }, {});
  
    // Function to sort filter items alphabetically by filter_name
    const sortedFilterGroups = Object.entries(groupedFilterGroups).map(([group_name, items]) => ({
        group_name,
        items: items.sort((a, b) => a.filter_name.localeCompare(b.filter_name)),
    }));

    // End of filters

    useEffect(() => {

        const fetchProductSections = async () => {
            try {

                if ( sectionId !== 'generic' ) {

                    const responseProduct = await axios.get(`${backendUrl}/a/fabrics/sections/${productId}/${sectionId}`, { withCredentials: true });
                    const _data = responseProduct.data.data.section;
                    const _is_expanded = responseProduct.data.data.is_expanded;
                    const _color_information = responseProduct.data.data.color_information;
                    const _fabric_information = responseProduct.data.data.fabric_information;

                    if ( _data === null ) {
                        setData([]);
                    } else {
                        setData(_data);
                        setCollectionName(responseProduct.data.data.collection);
                        setProductName(responseProduct.data.data.name);
                    }

                    if ( _color_information ) {
                        setColorInformation(_color_information);
                    }

                    if ( _fabric_information ) {
                        setFabricInformation(_fabric_information);
                    }

                    if ( _is_expanded ) {
                        setExpandedChecked('checked');
                    }

                    const responseColors = await axios.get(`${backendUrl}/a/products/blocks/colors`, { withCredentials: true });
                    setColors(responseColors.data.colors);

                    const responseFabrics = await axios.get(`${backendUrl}/a/products/blocks/fabrics`, { withCredentials: true });
                    setFabrics(responseFabrics.data.fabrics);

                    setStandardShown(responseProduct.data.data.standard.standard_shown);
                    setStandardCushions(responseProduct.data.data.standard.standard_cushions);
                    setStandardUmbrellas(responseProduct.data.data.standard.standard_umbrellas);
                    setStandardBrand(responseProduct.data.data.standard.standard_brand);
                    setStandardRepeat(responseProduct.data.data.standard.standard_repeat);
                    setStandardSelvedge(responseProduct.data.data.standard.standard_selvedge);
                    setStandardRoll(responseProduct.data.data.standard.standard_roll);
                    setStandardContent(responseProduct.data.data.standard.standard_content);
                    setStandardPerformance(responseProduct.data.data.standard.standard_performance);
                    setStandardFlammability(responseProduct.data.data.standard.standard_flammability);
                    setStandardDoubleRubs(responseProduct.data.data.standard.standard_doublerubs);

                    setIsLoading(false);

                } else {

                    const responseProduct = await axios.get(`${backendUrl}/a/fabrics/generic/${productId}`, { withCredentials: true });
                    const _data = responseProduct.data.images;
                    setData(_data);
                    setCollectionName(responseProduct.data.data.collection);
                    setProductName(responseProduct.data.data.name);

                    // Start of Filter
                    setFilterGroups(responseProduct.data.data.checkboxes);

                    setSelectedCheckboxes(responseProduct.data.data.checked.reduce((acc, checkbox) => {
                        acc[checkbox.filter_id] = true; // Set the checkbox as selected
                        return acc;
                    }, {}));

                    // End of filter

                    // set database defaults
                    console.log(responseProduct.data.data)

                    setNewCheckboxValue(responseProduct.data.data.general.is_new);
                    setActiveCheckboxValue(responseProduct.data.data.general.is_active);
                    setSlugValue((responseProduct.data.data.general.slug) ? responseProduct.data.data.general.slug : '');
                    setTitleTag((responseProduct.data.data.general.title_tag) ? responseProduct.data.data.general.title_tag : '');
                    setMetaDescription((responseProduct.data.data.general.meta_description) ? responseProduct.data.data.general.meta_description : '');
                    setProductCode(responseProduct.data.data.general.code);
                    setProductGrade(responseProduct.data.data.general.grade);

                    setCarePDFs(responseProduct.data.data.care);

                    setCollectionID( responseProduct?.data?.data?.general?.collection_id ? responseProduct?.data?.data?.general?.collection_id : '' );
                    setPerformanceID( responseProduct?.data?.data?.general?.performance_id ? responseProduct?.data?.data?.general?.performance_id : '' );

                    //setCollectionId( ( responseProduct.data.data.collection_id ) ? responseProduct.data.data.collection_id : '' );
                    setCare1Id( ( responseProduct.data.data.care1_id ) ? responseProduct.data.data.care1_id : '' );
                    setCare2Id( ( responseProduct.data.data.care2_id ) ? responseProduct.data.data.care2_id : '' );
                    setCare3Id( ( responseProduct.data.data.care3_id ) ? responseProduct.data.data.care3_id : '' );
                    setCare4Id( ( responseProduct.data.data.care4_id ) ? responseProduct.data.data.care4_id : '' );
                    setCare5Id( ( responseProduct.data.data.care5_id ) ? responseProduct.data.data.care5_id : '' );

                    const responseImages = await axios.get(`${backendUrl}/a/images/fabrics`, { withCredentials: true });
                    setImages(responseImages.data.images);

                    console.log(responseImages.data.images);
                    setIsLoading(false);

                }

            } catch (error) {
                console.log(error);
                setIsLoading(false);
                setIsError(true);
            }
        };
    
        fetchProductSections();

    }, []);

    // Modal
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState('');
    const [modalValue, setModalValue] = useState('');
    const [modalIndex, setModalIndex] = useState('');
    const [modalListIndex, setModalListIndex] = useState('');
    const [modalListValue, setModalListValue] = useState('');
    const [modalListULIndex, setModalListULIndex] = useState('');
    const [modalColorIndex, setModalColorIndex] = useState('');
    const [modalCellIndex, setModaCellIndex] = useState('');
    const [modalTableLeftValue, setModalTableLeftValue] = useState('');
    const [modalTableRightValue, setModalTableRightValue] = useState('');

    // Refs
    const modalEditTitle = useRef(null);
    const modalEditList = useRef(null);
    const modalAddList = useRef(null);
    const modalEditText = useRef(null);
    const modalAddFabrics = useRef(null);
    const modalAddTitleBlock = useRef(null);
    const modalAddTextBlock = useRef(null);
    const modalAddColor = useRef(null);
    const expandedRef = useRef(null);
    const modalAddImage = useRef(null);

    // Refs - Generic Information Page
    const isNewRef = useRef(null);
    const isActiveRef = useRef(null);


    const openModal = (type, value, index, listIndex, listValue) => {

        if ( type === 'addList' ) {
            setModalListULIndex(index);
        }

        if ( type === 'addColor' ) {
            setModalColorIndex(index);
        }

        if ( type === 'addCell' ) {
            setModaCellIndex(index);
        }

        if ( type === 'deleteCell' || type === 'editCell' ) {
            setModalTableLeftValue(data[index].table[listIndex].left);
            setModalTableRightValue(data[index].table[listIndex].right);
        }

        setModalValue(value);
        setModalIndex(index);
        setModalListIndex(listIndex);
        setModalListValue(listValue);
        setModalType(type);
        setIsModalOpen(true);

    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const saveModalData = (index, value, value2) => {
        // If the modal type is 'editList', update the text of the list item
        if (modalType === 'editList') {
            const updatedData = [...data];
            updatedData[index].list[modalListIndex] = value;
            setData(updatedData);
        } else if (modalType === 'editTitle') {
            // Update the title of the data item at the specified index with the new title
            const updatedData = [...data];
            updatedData[index].title = value;
            setData(updatedData);
        } else if (modalType === 'editText') {
            // Update the text data
            const updatedData = [...data];
            updatedData[index].text = value;
            setData(updatedData);
        } else if (modalType === 'editCell') {
            const updatedData = [...data];
            updatedData[index].table[modalListIndex] = {left: value, right: value2, type: 'item'};
            setData(updatedData);
        }
        closeModal();
    };

    const addModalDataBlock = (type, value) => {
        if (type === 'addTitle') {
            // Add title
            const addTitle = { title: value };
            const updatedData = [addTitle, ...data];
            setData(updatedData);
        } else if (type === 'addList') {
            // Add list
            const addList = { list: [] };
            const updatedData = [addList, ...data];
            setData(updatedData);
        } else if (type === 'addText') {
            // Add text
            const addText = { text: value };
            const updatedData = [addText, ...data];
            setData(updatedData);
        } else if (type === 'addFabrics') {
            // Add fabrics
            const addFabrics = { fabrics: [] };
            const updatedData = [addFabrics, ...data];
            setData(updatedData);
        } else if (type === 'addColors') {
            // Add colors
            const addColors = { colors: [] };
            const updatedData = [addColors, ...data];
            setData(updatedData);
        } else if (type === 'addTable') {
            // Add table
            const addTable = { table: [] };
            const updatedData = [addTable, ...data];
            setData(updatedData);
        }
        closeModal();
    };
   
    const deleteModalData = (type, index, listIndex) => {
        if ( type === 'title' ) {
            // Remove the data item at the specified index from the data array
            const updatedData = [...data];
            updatedData.splice(index, 1);
            setData(updatedData);
        } else if ( type === 'list' ) {
            // Remove the list item at the specified index from the list
            const updatedData = [...data];
            updatedData[index].list.splice(listIndex, 1);
            setData(updatedData);
        } else if ( type === 'block' ) {
            // Remove UL
            const updatedData = [...data];
            updatedData.splice(modalIndex, 1);
            setData(updatedData);
        } else if ( type === 'text' ) {
            // Remove text
            const updatedData = [...data];
            updatedData.splice(modalIndex, 1);
            setData(updatedData);
        } else if ( type === 'fabrics' ) {
            // Remove fabrics
            const updatedData = [...data];
            updatedData[index].fabrics.splice(listIndex, 1);
            setData(updatedData);
        } else if ( type === 'colors' ) {
            // Remove color
            const updatedData = [...data];
            updatedData[index].colors.splice(listIndex, 1);
            setData(updatedData);
        } else if ( type === 'table' ) {
            // Remove Table
            const updatedData = [...data];
            updatedData[index].table.splice(listIndex, 1);
            setData(updatedData);
        }
        closeModal();
    };
      
    const addModalDataList = (value) => {
        // Add the new item to the list
        const updatedData = [...data];
        updatedData[modalListULIndex].list.push(value);
        setData(updatedData);
        closeModal();
    };

    const addModalDataCell = (left, right) => {
        // Add the new item to the list
        const updatedData = [...data];
        updatedData[modalIndex].table = [{type: 'item', left: left, right: right}, ...updatedData[modalIndex].table];
        setData(updatedData);
        closeModal();
    };

    const addModalDataColor = (value) => {
        // Add the new item to the list
        console.log(value)
        const updatedData = [...data];
        updatedData[modalIndex].colors = [{relation_id: value}, ...updatedData[modalIndex].colors];
        setData(updatedData);
        closeModal();
    };

    const addModalDataFabric = (value) => {
        // Add the new item to the list
        console.log(value)
        const updatedData = [...data];
        updatedData[modalIndex].fabrics = [{relation_id: value}, ...updatedData[modalIndex].fabrics];
        setData(updatedData);
        closeModal();
    };

    const moveListItemUp = (blockIndex, itemIndex) => {
        const updatedData = [...data];
        const itemToMove = updatedData[blockIndex].list[itemIndex];
        updatedData[blockIndex].list.splice(itemIndex, 1);
        updatedData[blockIndex].list.splice(itemIndex - 1, 0, itemToMove);
        setData(updatedData);
    };
    
    const moveListItemDown = (blockIndex, itemIndex) => {
        const updatedData = [...data];
        const itemToMove = updatedData[blockIndex].list[itemIndex];
        updatedData[blockIndex].list.splice(itemIndex, 1);
        updatedData[blockIndex].list.splice(itemIndex + 1, 0, itemToMove);
        setData(updatedData);
    };
    
    // Function to move fabric item up
    const moveFabricUp = (blockIndex, itemIndex) => {
        const updatedData = [...data];
        const itemToMove = updatedData[blockIndex].fabrics[itemIndex];
        updatedData[blockIndex].fabrics.splice(itemIndex, 1);
        updatedData[blockIndex].fabrics.splice(itemIndex - 1, 0, itemToMove);
        setData(updatedData);
    };

    // Function to move fabric item down
    const moveFabricDown = (blockIndex, itemIndex) => {
        const updatedData = [...data];
        const itemToMove = updatedData[blockIndex].fabrics[itemIndex];
        updatedData[blockIndex].fabrics.splice(itemIndex, 1);
        updatedData[blockIndex].fabrics.splice(itemIndex + 1, 0, itemToMove);
        setData(updatedData);
    };

    // Function to move color item up
    const moveColorUp = (blockIndex, itemIndex) => {
        const updatedData = [...data];
        const itemToMove = updatedData[blockIndex].colors[itemIndex];
        updatedData[blockIndex].colors.splice(itemIndex, 1);
        updatedData[blockIndex].colors.splice(itemIndex - 1, 0, itemToMove);
        setData(updatedData);
    };

    // Function to move color item down
    const moveColorDown = (blockIndex, itemIndex) => {
        const updatedData = [...data];
        const itemToMove = updatedData[blockIndex].colors[itemIndex];
        updatedData[blockIndex].colors.splice(itemIndex, 1);
        updatedData[blockIndex].colors.splice(itemIndex + 1, 0, itemToMove);
        setData(updatedData);
    };

    const moveBlockUp = (index) => {
        // Move the data item at the specified index up by one position in the data array
        if (index > 0) {
            const updatedData = [...data];
            const temp = updatedData[index];
            updatedData[index] = updatedData[index - 1];
            updatedData[index - 1] = temp;
            setData(updatedData);
        }
    };

    const moveBlockDown = (index) => {
        // Move the data item at the specified index down by one position in the data array
        if (index < data.length - 1) {
            const updatedData = [...data];
            const temp = updatedData[index];
            updatedData[index] = updatedData[index + 1];
            updatedData[index + 1] = temp;
            setData(updatedData);
        }
    };

    // Function to move color item up
    const moveCellUp = (tableIndex, itemIndex) => {
        const updatedData = [...data];
        const itemToMove = updatedData[tableIndex].table[itemIndex];
        updatedData[tableIndex].table.splice(itemIndex, 1);
        updatedData[tableIndex].table.splice(itemIndex - 1, 0, itemToMove);
        setData(updatedData);
    };

    // Function to move cell item down
    const moveCellDown = (tableIndex, itemIndex) => {
        const updatedData = [...data];
        const itemToMove = updatedData[tableIndex].table[itemIndex];
        updatedData[tableIndex].table.splice(itemIndex, 1);
        updatedData[tableIndex].table.splice(itemIndex + 1, 0, itemToMove);
        setData(updatedData);
    };

    const syncBackend = () => {

        if ( sectionId !== 'generic' ) {

            const standard = {
                shown: standardShownRef.current.value,
                cushions: standardCushionsRef.current.value,
                umbrellas: standardUmbrellasRef.current.value,
                brand: standardBrandRef.current.value,
                repeat: standardRepeatRef.current.value,
                selvedge: standardSelvedgeRef.current.value,
                roll: standardRollRef.current.value,
                content: standardContentRef.current.value,
                performance: standardPerformanceRef.current.value,
                flammability: standardFlammabilityRef.current.value,
                doublerubs: standardDoubleRubsRef.current.value
            };

            const _data = {
                data: data,
                expanded: expandedRef.current.checked ? 'yes' : 'no',
                standard: standard
            };
    
            console.log(_data);

            const updateProductSections = async () => {
                try {
                    await axios.post(`${backendUrl}/a/fabrics/sections/${productId}/${sectionId}`, _data, { withCredentials: true });
                    setIsLoading(false);
                    window.showToast('WCL20415');
                } catch (error) {
                    console.log(error);
                    setIsLoading(false);
                    window.showToast('WCL20416');
                }
            };
        
            updateProductSections();   

        } else {

            // Generic

            // Validate SEO fields
            if (titleTag.length > 60 || metaDescription.length > 160) {
                return window.showToast('WCL20502');
            }

            const _data = {
                images: data,
                general: {
                    is_new: isNewRef?.current?.checked ? 'yes' : 'no',
                    is_active: isActiveRef?.current?.checked ? 'yes' : 'no',
                    slug: slugInputRef?.current?.value,
                    title_tag: titleTagRef?.current?.value,
                    meta_description: metaDescriptionRef?.current?.value,
                    name: productNameRef?.current?.value,
                    code: productCodeRef?.current?.value,
                    grade: productGradeRef?.current?.value,
                    care_1_id: careId1Ref?.current?.value,
                    care_2_id: careId2Ref?.current?.value,
                    care_3_id: careId3Ref?.current?.value,
                    care_4_id: careId4Ref?.current?.value,
                    care_5_id: careId5Ref?.current?.value,
                    collection_id: collectionRef?.current?.value,
                    performance_id: performanceRef?.current?.value,
                    filters: selectedCheckboxes
                }
            };

            const updateProductSections = async () => {
                try {
                    await axios.post(`${backendUrl}/a/fabrics/sections/${productId}/${sectionId}`, _data, { withCredentials: true });

                    setCollectionName();

                    collections.map((c, i) => {
                        if ( c.id === parseInt(collectionIdRef.current.value) ) {
                            setCollectionName(c.name);
                        }
                    });
                    
                    setIsLoading(false);
                    window.showToast('WCL20415');
                } catch (error) {
                    console.log(error);
                    setIsLoading(false);
                    window.showToast('WCL20424');
                }
            };
        
            updateProductSections();   

        }

    };

    let contentArray = [];
    let genericArray = [];
    let standardArray = [];

    if ( data && sectionId !== 'generic' ) {

        if ( data.length === 0 ) {
            contentArray.push(
                <div key={generateRandomKey()} className='flex w-full justify-center p-4 border border-dashed border-gray-200'>
                    Nothing to display.
                </div>
            );
        }
    
        data.forEach((item, index) => {
    
            if (item.title) {
                contentArray.push(
                    <div key={generateRandomKey()}>
                        <div className='p-4 bg-gray-100 w-full border border-gray-200'>
                            <div className='flex justify-between space-y-2'>
                                <div className='font-bold'>Title Block</div>
                                <div className='flex space-x-5'>
                                    {index > 0 && (
                                        <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveBlockUp(index)} }>Move Up</a>
                                    )}
                                    {index < data.length - 1 && (
                                        <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveBlockDown(index)} }>Move Down</a>
                                    )}
                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('editTitle', item.title, index)} }>Edit</a>
                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('deleteTitle', item.title, index)} }>Delete</a>
                                </div>
                            </div>
                            <div className='text-kb-300 uppercase font-bold text-xl'>{item.title}</div>
                        </div>
                        <div className='pt-5'></div>
                    </div>
                );
            }
    
            if (item.list) {
                contentArray.push(
                    <div key={generateRandomKey()}>
                        <div className='p-4 bg-gray-100 w-full space-y-4 border border-gray-200'>
                            <div className='flex justify-between'>
                                <div className='font-bold'>List Block</div>
                                <div className='flex space-x-5'>
                                    {index > 0 && (
                                        <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveBlockUp(index)} }>Move Up</a>
                                    )}
                                    {index < data.length - 1 && (
                                        <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveBlockDown(index)} }>Move Down</a>
                                    )}
                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('addList', null, index) }}>Add</a>
                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('deleteListBlock', null, index) }}>Delete</a>
                                </div>
                            </div>
                            <div className='bg-gray-50'>
                                <div>
    
                                    {item.list.length === 0 && (
                                        <div key={generateRandomKey()} className='text-center py-2'>
                                            This list is empty.
                                        </div>
                                    )}
    
                                    {item.list.length > 0 && item.list.map((listItem, listIndex) => (
                                        <div key={generateRandomKey()} className={`px-4 py-2 ${ listIndex === item.list.length - 1 ? '' : 'border-b border-gray-200' }`}>
                                            <div className='flex space-x-3'>
                                                <div className='text-gray-400'>{listIndex + 1}</div>
                                                <div className='font-medium'>{listItem}</div>
                                            </div>
                                            <div className='flex space-x-3 pt-3'>
                                                {listIndex > 0 && (
                                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveListItemUp(index, listIndex)} }>Move Up</a>
                                                )}
                                                {listIndex < item.list.length - 1 && (
                                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveListItemDown(index, listIndex)} }>Move Down</a>
                                                )}
                                                <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('editList', listItem, index, listIndex) }}>Edit</a>
                                                <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('deleteList', listItem, index, listIndex, listItem)} }>Delete</a>
                                            </div>
                                        </div>
                                    ))}
    
                                </div>
                            </div>
                        </div>
                        <div className='pt-5'></div>
                    </div>
                );
            }
    
            if (item.fabrics) {
                contentArray.push(
                    <div key={generateRandomKey()}>
                        <div className='p-4 bg-gray-100 w-full space-y-4 border border-gray-200'>
                            <div className='flex justify-between'>
                                <div className='font-bold'>Fabrics Block</div>
                                <div className='flex space-x-5'>
                                    {index > 0 && (
                                        <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveBlockUp(index)} }>Move Up</a>
                                    )}
                                    {index < data.length - 1 && (
                                        <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveBlockDown(index)} }>Move Down</a>
                                    )}
                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('addFabrics', null, index) }}>Add</a>
                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('deleteFabricsBlock', null, index) }}>Delete</a>
                                </div>
                            </div>
                            <div className='bg-gray-50'>
                                <div>
            
                                    {item.fabrics.length === 0 && (
                                        <div key={generateRandomKey()} className='text-center py-2'>
                                            This fabrics list is empty.
                                        </div>
                                    )}
            
                                    {item.fabrics.length > 0 && item.fabrics.map((image, listIndex) => (
                                        <div key={generateRandomKey()} className={`px-4 py-2 ${ listIndex === item.fabrics.length - 1 ? '' : 'border-b border-gray-200' }`}>
                                            <div className='flex space-x-3 items-center'>
                                                <div className='text-gray-400'>{listIndex + 1}</div>
                                                <div className=''><img src={`${staticUrl}/img/media/fabrics/thumbnail_${image.relation_id}.jpg`} className="transform transition duration-500 hover:scale-[1.5] w-[40px]" alt={`Fabric ${fabrics.find((fabric) => fabric.relation_id === image.relation_id) ? fabrics.find((fabric) => fabric.relation_id === image.relation_id).name : 'Fabric name not found.'}`} /></div>
                                                <div>{fabrics.find((fabric) => fabric?.relation_id === image?.relation_id) ? fabrics.find((fabric) => fabric?.relation_id === image?.relation_id).name : 'Fabric name not found.'}</div>
                                            </div>
                                            <div className='flex space-x-3 pt-3'>
                                                {listIndex > 0 && (
                                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveFabricUp(index, listIndex)} }>Move Up</a>
                                                )}
                                                {listIndex < item.fabrics.length - 1 && (
                                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveFabricDown(index, listIndex)} }>Move Down</a>
                                                )}
                                                <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('deleteFabrics', fabrics.find((fabric) => fabric?.relation_id === image?.relation_id)?.name, index, listIndex)} }>Delete</a>
                                            </div>
                                        </div>
                                    ))}
            
                                </div>
                            </div>
                        </div>
                        <div className='pt-5'></div>
                    </div>
                );
            }
    
            if (item.colors) {
                contentArray.push(
                    <div key={generateRandomKey()}>
                        <div className='p-4 bg-gray-100 w-full space-y-4 border border-gray-200'>
                            <div className='flex justify-between'>
                                <div className='font-bold'>Colors Block</div>
                                <div className='flex space-x-5'>
                                    {index > 0 && (
                                        <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveBlockUp(index)} }>Move Up</a>
                                    )}
                                    {index < data.length - 1 && (
                                        <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveBlockDown(index)} }>Move Down</a>
                                    )}
                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('addColors', null, index) }}>Add</a>
                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('deleteColorsBlock', null, index) }}>Delete</a>
                                </div>
                            </div>
                            <div className='bg-gray-50'>
                                <div>
            
                                    {item.colors.length === 0 && (
                                        <div key={generateRandomKey()} className='text-center py-2'>
                                            This colors block is empty.
                                        </div>
                                    )}
    
                                    {item.colors.length > 0 && item.colors.map((image, listIndex) => (
                                        <div key={generateRandomKey()} className={`px-4 py-2 ${ listIndex === item.colors.length - 1 ? '' : 'border-b border-gray-200' }`}>
                                            <div className='flex space-x-3 items-center'>
                                                <div className='text-gray-400'>{listIndex + 1}</div>
                                                <div className=''><img src={`${staticUrl}/img/media/colors/thumbnail_${image.relation_id}.jpg`} className="transform transition duration-500 hover:scale-[1.5] w-[40px]" alt={`Color ${colors.find((color) => color.relation_id === image.relation_id) ? colors.find((color) => color.relation_id === image.relation_id).name : 'Color name not found.'}`} /></div>
                                                <div>{colors.find((color) => color.relation_id === image.relation_id) ? colors.find((color) => color.relation_id === image.relation_id).name : 'Color name not found.'}</div>
                                            </div>
                                            <div className='flex space-x-3 pt-3'>
                                                {listIndex > 0 && (
                                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveColorUp(index, listIndex)} }>Move Up</a>
                                                )}
                                                {listIndex < item.colors.length - 1 && (
                                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveColorDown(index, listIndex)} }>Move Down</a>
                                                )}
                                                <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('deleteColors', colors.find((color) => color.relation_id === image.relation_id).name, index, listIndex)} }>Delete</a>
                                            </div>
                                        </div>
                                    ))}
            
                                </div>
                            </div>
                        </div>
                        <div className='pt-5'></div>
                    </div>
                );
            }
    
            if (item.text) {
                contentArray.push(
                    <div key={generateRandomKey()}>
                        <div className='p-4 bg-gray-100 w-full border border-gray-200'>
                            <div className='flex justify-between space-y-2'>
                                <div className='font-bold'>Text Block</div>
                                <div className='flex space-x-5'>
                                    {index > 0 && (
                                        <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveBlockUp(index)} }>Move Up</a>
                                    )}
                                    {index < data.length - 1 && (
                                        <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveBlockDown(index)} }>Move Down</a>
                                    )}
                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('editText', item.text, index)} }>Edit</a>
                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('deleteText', item.text, index)} }>Delete</a>
                                </div>
                            </div>
                            <div className=''>{item.text}</div>
                        </div>
                        <div className='pt-5'></div>
                    </div>
                );
            }
    
            if (item.table) {
                contentArray.push(
                    <div key={generateRandomKey()}>
                        <div className='p-4 bg-gray-100 w-full border border-gray-200'>
                            <div className='flex justify-between pb-4'>
                            <div className='font-bold'>Table Block</div>
                                <div className='flex space-x-5'>
                                    {index > 0 && (
                                        <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveBlockUp(index)} }>Move Up</a>
                                    )}
                                    {index < data.length - 1 && (
                                        <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveBlockDown(index)} }>Move Down</a>
                                    )}
                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('addCell', item.text, index)} }>Add</a>
                                    <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('deleteTable', item.text, index)} }>Delete</a>
                                </div>
                            </div>
                            <div className='p-4 pb-0 bg-gray-50'>
                            {item.table.map((row, tableIndex) => (
                                row.type === 'item' ? (
                                    <div key={generateRandomKey()}>
                                        <div className={`grid grid-cols-3 bg-gray-50/75 text-sm`}>
                                            <div className='bg-kb-300/10 grid-cols-1 text-kb-300 p-2 pl-4 border-r border-kb-300/50 font-medium'>{row.left}</div>
                                            <div className='grid-cols-2 p-2 pl-4 text-kb-300'>{row.right}</div>
                                        </div>
                                        <div className='flex space-x-3 py-3'>
                                            {tableIndex > 0 && (
                                                <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveCellUp(index, tableIndex)} }>Move Up</a>
                                            )}
                                            {tableIndex < item.table.length - 1 && (
                                                <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); moveCellDown(index, tableIndex)} }>Move Down</a>
                                            )}
                                            <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('editCell', null, index, tableIndex) }}>Edit</a>
                                            <a href="#" className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('deleteCell', null, index, tableIndex)}  }>Delete</a>
                                        </div>
                                    </div>
                                ) : (
                                    <div key={generateRandomKey()} className={`grid grid-cols-3 bg-kb-300/10 ${index < item.table.length - 1 ? 'border-b-2 border-kb-300/50' : ''}`}>
                                        <div className='grid-cols-1 text-kb-300 p-2 pl-4 border-r border-kb-300/50 font-medium'>{row.left}</div>
                                        <div className='grid-cols-2 text-kb-300 p-2 pl-4 font-medium'>{row.right}</div>
                                    </div>
                                )
                            ))}
                            </div>
                        </div>
                        <div className='pt-5'></div>
                    </div>
                );                        
            }
           
        });

    }

    const handleDragEnd = (result) => {
        const { source, destination } = result;
        if (!destination) return;

        const startIndex = source.index;
        const endIndex = destination.index;
        
        // Reorder the data array based on the source and destination indexes
        const newData = Array.from(data);
        const [removed] = newData.splice(startIndex, 1);
        newData.splice(endIndex, 0, removed);
        
        // Update the data state with the new order
        setData(newData);
    };

    const addImage = (index) => {
        const _data = [{ relation_id: images[index].relation_id, name: images[index].name, date: images[index].date }, ...data];
        setData(_data);
    };

    const removeImage = (index) => {
        // Create a copy of the data array
        const newData = [...data];
        // Remove the image at the specified index from the newData array
        newData.splice(index, 1);
        // Update the data state with the new array
        setData(newData);
        closeModal();
    };
    
    standardArray.push(
        <div key={generateRandomKey()} className='p-4 bg-gray-50 w-full space-y-5 border border-gray-200 mb-5'>
            <h3 className='font-bold'>Orientation</h3>
            <div className='space-y-5 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-4'>
                <div className='flex items-center space-x-3'>
                    <div className='font-bold whitespace-nowrap'>Shown</div>
                    <div className='w-full'>
                        <input ref={standardShownRef} type="text" defaultValue={standardShown} className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                    </div>
                </div>
                <div className='flex items-center space-x-3'>
                    <div className='font-bold whitespace-nowrap'>Cushions</div>
                    <div className='w-full'>
                        <input ref={standardCushionsRef} type="text" defaultValue={standardCushions} className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                    </div>
                </div>
                <div className='flex items-center space-x-3'>
                    <div className='font-bold whitespace-nowrap'>Umbrellas</div>
                    <div className='w-full'>
                        <input ref={standardUmbrellasRef} type="text" defaultValue={standardUmbrellas} className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                    </div>
                </div>
            </div>
        </div>
    );

    standardArray.push(
        <div key={generateRandomKey()} className='p-4 bg-gray-50 w-full space-y-5 border border-gray-200 mb-5'>
            <h3 className='font-bold'>Details</h3>
            <div className='space-y-5 lg:space-y-0 lg:grid lg:grid-cols-4 lg:gap-4'>
                <div className='flex items-center space-x-3'>
                    <div className='font-bold whitespace-nowrap'>Brand</div>
                    <div className='w-full'>
                        <input ref={standardBrandRef} type="text" defaultValue={standardBrand} className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                    </div>
                </div>
                <div className='flex items-center space-x-3'>
                    <div className='font-bold whitespace-nowrap'>Repeat</div>
                    <div className='w-full'>
                        <input ref={standardRepeatRef} type="text" defaultValue={standardRepeat} className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                    </div>
                </div>
                <div className='flex items-center space-x-3'>
                    <div className='font-bold whitespace-nowrap'>Selvedge</div>
                    <div className='w-full'>
                        <input ref={standardSelvedgeRef} type="text" defaultValue={standardSelvedge} className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                    </div>
                </div>
                <div className='flex items-center space-x-3'>
                    <div className='font-bold whitespace-nowrap'>Roll Width</div>
                    <div className='w-full'>
                        <input ref={standardRollRef} type="text" defaultValue={standardRoll} className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                    </div>
                </div>
            </div>
        </div>
    );

    standardArray.push(
        <div key={generateRandomKey()} className='p-4 bg-gray-50 w-full space-y-5 border border-gray-200 mb-5'>
            <h3 className='font-bold'>Specifications</h3>
            <div className='space-y-5 lg:space-y-0 lg:grid lg:grid-cols-4 lg:gap-4'>
                <div className='flex items-center space-x-3'>
                    <div className='font-bold whitespace-nowrap'>Content</div>
                    <div className='w-full'>
                        <input ref={standardContentRef} type="text" defaultValue={standardContent} className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                    </div>
                </div>
                <div className='flex items-center space-x-3'>
                    <div className='font-bold whitespace-nowrap'>Performance</div>
                    <div className='w-full'>
                        <input ref={standardPerformanceRef} type="text" defaultValue={standardPerformance} className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                    </div>
                </div>
                <div className='flex items-center space-x-3'>
                    <div className='font-bold whitespace-nowrap'>Flammability</div>
                    <div className='w-full'>
                        <input ref={standardFlammabilityRef} type="text" defaultValue={standardFlammability} className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                    </div>
                </div>
                <div className='flex items-center space-x-3'>
                    <div className='font-bold whitespace-nowrap'>Double Rubs</div>
                    <div className='w-full'>
                        <input ref={standardDoubleRubsRef} type="text" defaultValue={standardDoubleRubs} className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                    </div>
                </div>
            </div>
        </div>
    );


    if ( data && sectionId === 'generic' ) {

        if ( data.length === 0 ) {
            genericArray.push(
                <div key={generateRandomKey()} className='p-4 bg-gray-50 w-full space-y-4 border border-gray-200'>
                    <div className='flex justify-between items-center'>
                        <div className='font-bold'>Images</div>
                        <a href='#' className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('addImage') }}>Add Image</a>
                    </div>

                    <div className='flex w-full justify-center p-4 border border-dashed border-gray-200 bg-white'>
                        Nothing to display.
                    </div>
                </div>
            );
        }
    
        if ( data.length > 0 ) {
            genericArray.push(
                <div key={generateRandomKey()} >
                    <div className='p-4 bg-gray-50 w-full space-y-4 border border-gray-200'>
                        <div className='flex justify-between items-center'>
                            <div className='font-bold'>Images</div>
                            <a href='#' className='hover:underline' onClick={(e) => { e.preventDefault(); openModal('addImage') }}>Add Image</a>
                        </div>
                        <DragDropContext onDragEnd={handleDragEnd}>
                            <Droppable droppableId={`images`} type="IMAGES">
                                {(provided) => (
                                <div {...provided.droppableProps} ref={provided.innerRef} className="border-t border-l border-r border-gray-200 mt-4">
                                    {data.map((image, index) => {
                                        const imageDate = new Date(image.date);
                                        const formattedDate = imageDate.toLocaleString('en-US', {
                                            year: 'numeric',
                                            month: '2-digit',
                                            day: '2-digit',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                        });
                                        return (
                                            <Draggable key={`image-${index}`} draggableId={`image-${index}`} index={index}>
                                                {(provided) => (
                                                    <div ref={provided.innerRef} {...provided.draggableProps} className="p-4 bg-gray-100 border-b border-gray-200 gap-x-3 items-center">
                                                        <div className="flex items-center">
                                                            <div className="text-kb-300/50 hover:text-kb-300" {...provided.dragHandleProps}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="fill-current text-kb-300/50 hover:fill-kb-300 hover:text-kb-300" ><circle cx="12" cy="6" r="2"></circle> <circle cx="12" cy="12" r="2"></circle> <circle cx="12" cy="18" r="2"></circle> <circle cx="6" cy="6" r="2"></circle> <circle cx="6" cy="12" r="2"></circle> <circle cx="6" cy="18" r="2"></circle></svg>
                                                            </div>
                                                            <div className="flex items-center justify-between w-full">
                                                                <div className='flex items-center space-x-3'>
                                                                    <img src={`${staticUrl}/img/media/fabrics/thumbnail_${image.relation_id}.jpg`} className="transform transition duration-500 hover:scale-[1.5] w-[40px]" alt={`Image ${image.name}`} />
                                                                    <div className=''>
                                                                        <div className="font-bold">{image.name}</div>
                                                                        <div className="text-sm">{image.description}</div>
                                                                        <div className="text-sm">{formattedDate}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="flex gap-x-6">
                                                                    <a href="#" className="hover:text-kb-300 hover:underline" onClick={(e) => { e.preventDefault(); openModal('deleteImage', image.name, index)}}>Delete</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        );
                                    })}
                                    {provided.placeholder}
                                </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </div>
            );
        }

    }

    if (isLoading) {
        return <Loading />;
    }

    if (isError) {
        return (
            <>

                <Session />
                <Title set="Fabrics Admin" />
                <div className="App">
                    
                    <div className="antialiased">
                        <Navbar />
                        <Sidenav />
                        <main className="p-4 lg:pl-[270px] h-screen max-w-screen-2xl pt-20 z-0 mx-auto">
                            <div className='flex w-full justify-center p-4 border border-dashed border-gray-200'>
                                Fabric or section does not exist.
                            </div>
                        </main>
                    </div>

                </div>
            
            </>
        );
    }

    return (
        <>
            <Session />
            <Title set="Fabrics Admin" />
            <div className="App">
                
                <div className="antialiased">
                    <Navbar />
                    <Sidenav />
                    <main className="p-4 lg:pl-[270px] h-screen max-w-screen-2xl pt-20 z-0 mx-auto">
                        <div className='flex'>
                            <div className='hidden lg:block lg:fixed top-[95px] p-4 space-y-3 border border-dashed border-gray-200 bg-gray-50'>
                                <div className='font-bold'>SECTIONS</div>
                                <div><a href={`${frontendUrl}/admin/fabrics/${productId}/generic`} className='hover:underline'>Generic Information</a></div>
                                <div><a href={`${frontendUrl}/admin/fabrics/${productId}/details`} className='hover:underline'>Details</a></div>
                                <div className='pt-5'><Button size='sm' text='UPDATE SECTION' onClick={() => { syncBackend(); }} /></div>
                            </div>
                            <div className='lg:ml-[195px] w-full'>
                                <div className='block lg:hidden p-4 border border-dashed border-gray-200 bg-gray-50 space-x-0'>
                                    <div className='font-bold'>SECTIONS</div>
                                    <div><a href={`${frontendUrl}/admin/fabrics/${productId}/generic`} className='hover:underline'>Generic Information</a></div>
                                    <div><a href={`${frontendUrl}/admin/fabrics/${productId}/details`} className='hover:underline'>Details</a></div>
                                </div>
                                <div className='lg:flex justify-between items-center'>
                                    <div className=''>
                                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light py-7 uppercase'>{collectionName} {productName}</h2>
                                    </div>
                                    <div className='mb-10 lg:mb-0 justify-center lg:justify-start flex gap-x-3'>
                                        <Button size='sm' text='UPDATE SECTION' onClick={() => { syncBackend(); }} />
                                    </div>
                                </div>
                                <div className='text-xl bg-gray-200 p-4 flex justify-between items-center'>
                                    <div className='flex space-x-2'>
                                        <span className='font-bold'>{translate[sectionId]}</span> { sectionId !== 'generic' && <div>Section</div> }
                                    </div>
                                    { sectionId !== 'generic' && (
                                        <div className='text-base flex space-x-3'>
                                            <div style={{ marginTop: '3px' }}><input type="checkbox" ref={expandedRef} defaultChecked={expandedChecked} className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block cursor-pointer" /></div>
                                            <div>Expanded</div>
                                        </div>
                                    )}
                                </div>
                                <div className='lg:flex justify-between items-center mb-10 w-full bg-gray-50 border border-gray-200'>
                                    <div className='justify-center lg:justify-start lg:flex lg:space-x-3 space-y-3 lg:space-y-0 p-4 w-full'>
                                        { sectionId !== 'generic' && (
                                            <>
                                                <Button size='sm' text='NEW TITLE' onClick={() => { openModal('addTitleBlock') }} />
                                                <Button size='sm' text='NEW LIST' onClick={() => { openModal('addListBlock') }} />
                                                <Button size='sm' text='NEW TEXT' onClick={() => { openModal('addTextBlock') }} />
                                                <Button size='sm' text='NEW FABRICS' onClick={() => { openModal('addFabricsBlock') }} />
                                                <Button size='sm' text='NEW COLORS' onClick={() => { openModal('addColorsBlock') }} />
                                                <Button size='sm' text='NEW TABLE' onClick={() => { openModal('addTable') }} />
                                            </>
                                        )}
                                        { sectionId === 'generic' && (
                                            <div className='w-full'>
                                                <div className='space-y-5 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-5'>
                                                    <div className='flex space-x-5'>
                                                        <div className='flex items-center space-x-3'>
                                                            <div className='font-bold'>New</div>
                                                            <div>
                                                                <input type="checkbox" ref={isNewRef} defaultChecked={newCheckboxValue} className="cursor-pointer bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block" />
                                                            </div>
                                                        </div>
                                                        <div className='flex items-center space-x-3'>
                                                            <div className='font-bold'>Active</div>
                                                            <div>
                                                                <input type="checkbox" ref={isActiveRef} defaultChecked={activeCheckboxValue} className="cursor-pointer bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block" />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='flex items-center space-x-3'>
                                                        <div className='font-bold'>Slug</div>
                                                        <div className='w-full'>
                                                            <SlugInput ref={slugInputRef} value={slugValue} onChange={() => { setSlugValue(slugInputRef.current.value) }} />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className='space-y-3'>
                                    <div className='w-full'>
                                        { sectionId === 'generic' && (
                                            <>

                                                <div className='p-4 bg-gray-50 w-full space-y-5 border border-gray-200 mb-5'>
                                                    <h3 className='font-bold'>SEO Fields</h3>
                                                    <div className='space-y-5'>
                                                        <div className='space-y-2'>
                                                            <div className='flex items-center justify-between'>
                                                                <div className='font-bold'>Title Tag (Search Result Title) (optional)</div>
                                                                <div className='text-sm text-gray-500'>
                                                                    {titleTag.length}/60
                                                                </div>
                                                            </div>
                                                            <input
                                                                ref={titleTagRef}
                                                                type="text"
                                                                value={titleTag}
                                                                onChange={(e) => setTitleTag(e.target.value)}
                                                                maxLength="60"
                                                                placeholder="Custom title for search engines and browser tabs"
                                                                className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full"
                                                            />
                                                            <div className='text-xs text-gray-500'>
                                                                Leave blank to use the automatic title: {'{Fabric Name}'} | Kingsley Bate.
                                                            </div>
                                                        </div>
                                                        <div className='space-y-2'>
                                                            <div className='flex items-center justify-between'>
                                                                <div className='font-bold'>Meta Description</div>
                                                                <div className='text-sm text-gray-500'>
                                                                    {metaDescription.length}/160 characters
                                                                </div>
                                                            </div>
                                                            <textarea
                                                                ref={metaDescriptionRef}
                                                                value={metaDescription}
                                                                onChange={(e) => setMetaDescription(e.target.value)}
                                                                maxLength="160"
                                                                rows="3"
                                                                placeholder="Brief description for search engine results"
                                                                className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full"
                                                            />
                                                            <div className='text-xs text-gray-500'>
                                                                Leave blank to use the current default behavior.
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='p-4 bg-gray-50 w-full space-y-5 border border-gray-200 mb-5'>
                                                    <h3 className='font-bold'>General</h3>
                                                    <div className='space-y-5 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-4 pb-6'>
                                                        <div className='flex items-center space-x-3'>
                                                            <div className='font-bold whitespace-nowrap'>Name</div>
                                                            <div className='w-full relative'>
                                                                <input ref={productNameRef} type="text" defaultValue={productName} className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                                                                <div className='absolute left-0 top-full mt-2 text-xs text-gray-500 whitespace-nowrap'>Used as the page H1 heading for SEO.</div>
                                                            </div>
                                                        </div>
                                                        <div className='flex items-center space-x-3'>
                                                            <div className='font-bold whitespace-nowrap'>Code</div>
                                                            <div className='w-full'>
                                                                <input ref={productCodeRef} type="text" defaultValue={productCode} className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                                                            </div>
                                                        </div>
                                                        <div className='flex items-center space-x-3'>
                                                            <div className='font-bold whitespace-nowrap'>Grade</div>
                                                            <div className='w-full'>
                                                                <input ref={productGradeRef} type="text" defaultValue={productGrade} className="bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='p-4 bg-gray-50 w-full space-y-5 border border-gray-200 mb-5'>
                                                    <h3 className='font-bold'>Collection & Performance</h3>
                                                    <div className='space-y-5 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-4'>
                                                        <div className='flex items-center space-x-3'>
                                                            <div className='font-bold whitespace-nowrap'>Collection</div>
                                                            <div className='w-full'>
                                                                <select ref={collectionRef} value={collectionID} onChange={(e) => setCollectionID(e.target.value)} className='bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 w-full'>
                                                                    <option value=''>No Collection</option>
                                                                    <option disabled className='text-gray-300'>-------------------------------------</option>
                                                                    {collection.map((item, index) => (
                                                                        <option key={generateRandomKey()} value={item.value}>{item.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className='flex items-center space-x-3'>
                                                            <div className='font-bold whitespace-nowrap'>Performance</div>
                                                            <div className='w-full'>
                                                                <select ref={performanceRef} value={performanceID} onChange={(e) => setPerformanceID(e.target.value)} className='bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 w-full'>
                                                                    <option value=''>No Performance</option>
                                                                    <option disabled className='text-gray-300'>-------------------------------------</option>
                                                                    {performance.map((item, index) => (
                                                                        <option key={generateRandomKey()} value={item.value}>{item.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='p-4 bg-gray-50 w-full space-y-5 border border-gray-200 mb-5'>
                                                    <h3 className='font-bold'>Product Care</h3>

                                                    <div className='space-y-5 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-4'>
                                                        <div className='flex items-center space-x-3'>
                                                            <div className='font-bold whitespace-nowrap'>Care PDF 1</div>
                                                            <div className='w-full'>
                                                                <select ref={careId1Ref} value={care1Id} onChange={(e) => setCare1Id(e.target.value)} className='bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 w-full'>
                                                                    <option value=''>No Care</option>
                                                                    <option disabled className='text-gray-300'>-------------------------------------</option>
                                                                    {carePDFs.map((item, index) => (
                                                                        <option key={generateRandomKey()} value={item.id}>{item.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className='flex items-center space-x-3'>
                                                            <div className='font-bold whitespace-nowrap'>Care PDF 2</div>
                                                            <div className='w-full'>
                                                                <select ref={careId2Ref} value={care2Id} onChange={(e) => setCare2Id(e.target.value)} className='bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 w-full'>
                                                                    <option value=''>No Care</option>
                                                                    <option disabled className='text-gray-300'>-------------------------------------</option>
                                                                    {carePDFs.map((item, index) => (
                                                                        <option key={generateRandomKey()} value={item.id}>{item.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className='flex items-center space-x-3'>
                                                            <div className='font-bold whitespace-nowrap'>Care PDF 3</div>
                                                            <div className='w-full'>
                                                                <select ref={careId3Ref} value={care3Id} onChange={(e) => setCare3Id(e.target.value)} className='bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 w-full'>
                                                                    <option value=''>No Care</option>
                                                                    <option disabled className='text-gray-300'>-------------------------------------</option>
                                                                    {carePDFs.map((item, index) => (
                                                                        <option key={generateRandomKey()} value={item.id}>{item.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className='flex items-center space-x-3'>
                                                            <div className='font-bold whitespace-nowrap'>Care PDF 4</div>
                                                            <div className='w-full'>
                                                                <select ref={careId4Ref} value={care4Id} onChange={(e) => setCare4Id(e.target.value)} className='bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 w-full'>
                                                                    <option value=''>No Care</option>
                                                                    <option disabled className='text-gray-300'>-------------------------------------</option>
                                                                    {carePDFs.map((item, index) => (
                                                                        <option key={generateRandomKey()} value={item.id}>{item.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className='flex items-center space-x-3'>
                                                            <div className='font-bold whitespace-nowrap'>Care PDF 5</div>
                                                            <div className='w-full'>
                                                                <select ref={careId5Ref} value={care5Id} onChange={(e) => setCare5Id(e.target.value)} className='bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 w-full'>
                                                                    <option value=''>No Care</option>
                                                                    <option disabled className='text-gray-300'>-------------------------------------</option>
                                                                    {carePDFs.map((item, index) => (
                                                                        <option key={generateRandomKey()} value={item.id}>{item.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='mb-5'>
                                                    {genericArray}
                                                </div>

                                                <div className='p-4 bg-gray-50 w-full space-y-4 border border-gray-200 mb-5'>
                                                    <h3 className='font-bold'>Filters</h3>
                                                    {sortedFilterGroups.map(({ group_name, items }) => (
                                                        <div key={group_name} className='p-4 w-full space-y-4 border border-gray-200 mb-5 bg-white'>
                                                            <h3 className='font-bold'>{group_name}</h3>
                                                            <div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
                                                                {items.map((filterItem) => (
                                                                    <div key={filterItem.filter_id} className='space-y-2'>
                                                                        <div>{filterItem.filter_name}</div>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedCheckboxes[filterItem.filter_id] || false}
                                                                            onChange={() => handleCheckboxChange(filterItem.filter_id)}
                                                                            className="cursor-pointer bg-white border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block"
                                                                        />
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>

                                            </>
                                        )}

                                        { sectionId === 'details' && (
                                            <>
                                                <div>
                                                    {standardArray}
                                                </div>
                                                <div>
                                                    {contentArray}
                                                </div>
                                            </>
                                        )}

                                        { (sectionId !== 'generic' && sectionId !== 'details') && (
                                            <div>
                                                {contentArray}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>

            </div>


            <Modal isOpen={isModalOpen} onClose={closeModal} className='p-0 space-y-6' button width='w-[90%] md:w-[80%] lg:w-[60%] xl:w-[50%] 2xl:w-[40%]'>

            {modalType === 'editCell' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Delete Table Cell</h2>
                        <div className='space-y-6'>
                            <div>
                                <div className='font-bold'>Are you sure you want to delete this colors block?</div>
                            </div>
                            <div className='grid grid-cols-2 gap-4'>
                                <div className=''>
                                    <div className='font-bold'>Item</div>
                                    <input type="text" ref={modalEditCellLeft} defaultValue={modalTableLeftValue} className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                                </div>
                                <div className=''>
                                    <div className='font-bold'>Description</div>
                                    <input type="text" ref={modalEditCellRight} defaultValue={modalTableRightValue} className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                                </div>
                            </div>
                            <Button size='sm' text='UPDATE' onClick={() => saveModalData(modalIndex, modalEditCellLeft.current.value, modalEditCellRight.current.value)} />
                        </div>
                    </>
                )}

                {modalType === 'deleteCell' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Delete Table Cell</h2>
                        <div className='space-y-6'>
                            <div>
                                <div className='font-bold'>Are you sure you want to delete this colors block?</div>
                            </div>
                            <div className='grid grid-cols-2 gap-4'>
                                <div className=''>
                                    <div className='font-bold'>Item</div>
                                    <input type="text" disabled defaultValue={modalTableLeftValue} className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                                </div>
                                <div className=''>
                                    <div className='font-bold'>Description</div>
                                    <input type="text" disabled defaultValue={modalTableRightValue} className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                                </div>
                            </div>
                            <Button size='sm' text='DELETE' onClick={() => deleteModalData('table', modalIndex, modalListIndex)} />
                        </div>
                    </>
                )}

                {modalType === 'addCell' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Add Table Cell</h2>
                        <div className='space-y-6'>
                            <div className='grid grid-cols-2 gap-4'>
                                <div className=''>
                                    <div className='font-bold'>Item</div>
                                    <input type="text" ref={modalAddCellLeft} defaultValue='' className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                                </div>
                                <div className=''>
                                    <div className='font-bold'>Description</div>
                                    <input type="text" ref={modalAddCellRight} defaultValue='' className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                                </div>
                            </div>
                            <Button size='sm' text='ADD' onClick={() => addModalDataCell(modalAddCellLeft.current.value, modalAddCellRight.current.value)} />

                        </div>
                    </>
                )}

                {modalType === 'deleteTable' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Delete Table</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Are you sure you want to delete this list table?</div>
                            </div>
                            <Button size='sm' text='DELETE' onClick={() => deleteModalData('block')} />

                        </div>
                    </>
                )}

                {modalType === 'addTable' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Add Table</h2>
                        <div className='space-y-6'>
                            <Button size='sm' text='ADD' onClick={() => addModalDataBlock('addTable')} />
                        </div>
                    </>
                )}

                {modalType === 'addImage' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Add Image</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Select Image</div>
                                <select ref={modalAddImage} className='bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300'>
                                    {images.map((image, index) => (
                                        <option key={generateRandomKey()} value={index}>{image.name}</option>
                                    ))}
                                </select>
                            </div>
                            <Button size='sm' text='ADD' onClick={() => addImage(modalAddImage.current.value)} />
                        </div>
                    </>
                )}

                {modalType === 'deleteImage' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Delete Images</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Are you sure you want to delete this image item?</div>
                                <input type="text" defaultValue={modalValue} className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full select-none" disabled />
                            </div>
                            <Button size='sm' text='DELETE' onClick={() => removeImage(modalIndex)} />

                        </div>
                    </>
                )}

                {modalType === 'addColorsBlock' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Add Colors Block</h2>
                        <div className='space-y-6'>
                            <Button size='sm' text='ADD' onClick={() => addModalDataBlock('addColors')} />
                        </div>
                    </>
                )}

                {modalType === 'addFabricsBlock' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Add Fabrics Block</h2>
                        <div className='space-y-6'>
                            <Button size='sm' text='ADD' onClick={() => addModalDataBlock('addFabrics')} />
                        </div>
                    </>
                )}

                {modalType === 'addColors' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Add Color Item</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Select Color</div>
                                <select ref={modalAddColor} className='bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300'>
                                    {colors.map((color, index) => (
                                        <option key={generateRandomKey()} value={color.relation_id}>{color.name}</option>
                                    ))}
                                </select>
                            </div>
                            <Button size='sm' text='ADD' onClick={() => addModalDataColor(modalAddColor.current.value)} />
                        </div>
                    </>
                )}

                {modalType === 'deleteColorsBlock' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Delete Block</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Are you sure you want to delete this colors block?</div>
                            </div>
                            <Button size='sm' text='DELETE' onClick={() => deleteModalData('block')} />

                        </div>
                    </>
                )}

                {modalType === 'deleteColors' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Delete Colors</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Are you sure you want to delete this color item?</div>
                                <input type="text" defaultValue={modalValue} className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full select-none" disabled />
                            </div>
                            <Button size='sm' text='DELETE' onClick={() => deleteModalData('colors', modalIndex, modalListIndex)} />

                        </div>
                    </>
                )}

                {modalType === 'addFabrics' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Add Fabric Item</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Select Fabric</div>
                                <select ref={modalAddFabrics} className='bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300'>
                                    {fabrics.map((fabric, index) => (
                                        <option key={generateRandomKey()} value={fabric.relation_id}>{fabric.name}</option>
                                    ))}
                                </select>
                            </div>
                            <Button size='sm' text='ADD' onClick={() => addModalDataFabric(modalAddFabrics.current.value)} />
                        </div>
                    </>
                )}

                {modalType === 'deleteFabrics' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Delete Fabrics</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Are you sure you want to delete this fabrics item?</div>
                                <input type="text" defaultValue={modalValue} className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full select-none" disabled />
                            </div>
                            <Button size='sm' text='DELETE' onClick={() => deleteModalData('fabrics', modalIndex, modalListIndex)} />

                        </div>
                    </>
                )}

                {modalType === 'deleteFabricsBlock' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Delete Block</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Are you sure you want to delete this fabrics block?</div>
                            </div>
                            <Button size='sm' text='DELETE' onClick={() => deleteModalData('block')} />

                        </div>
                    </>
                )}

                {modalType === 'addTextBlock' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Add Text Block</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Text</div>
                                <input type="text" ref={modalAddTextBlock} defaultValue='' className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                            </div>
                            <Button size='sm' text='ADD' onClick={() => addModalDataBlock('addText', modalAddTextBlock.current.value)} />
                        </div>
                    </>
                )}

                {modalType === 'editText' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Edit Text</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Text</div>
                                <input type="text" ref={modalEditText} defaultValue={modalValue} className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                            </div>
                            <Button size='sm' text='UPDATE' onClick={() => saveModalData(modalIndex, modalEditText.current.value)} />

                        </div>
                    </>
                )}

                {modalType === 'deleteText' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Delete Title</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Are you sure you want to delete this text?</div>
                                <input type="text" defaultValue={modalValue} className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full select-none" disabled />
                            </div>
                            <Button size='sm' text='DELETE' onClick={() => deleteModalData('text', modalIndex)} />

                        </div>
                    </>
                )}

                {modalType === 'addListBlock' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Add List Block</h2>
                        <div className='space-y-6'>
                            <Button size='sm' text='ADD' onClick={() => addModalDataBlock('addList')} />
                        </div>
                    </>
                )}

                {modalType === 'addList' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Add List Item</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>List Item</div>
                                <input type="text" ref={modalAddList} defaultValue='' className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                            </div>
                            <Button size='sm' text='ADD' onClick={() => addModalDataList(modalAddList.current.value)} />

                        </div>
                    </>
                )}

                {modalType === 'editList' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Edit List Item</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>List Item</div>
                                <input type="text" ref={modalEditList} defaultValue={modalValue} className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                            </div>
                            <Button size='sm' text='UPDATE' onClick={() => saveModalData(modalIndex, modalEditList.current.value)} />

                        </div>
                    </>
                )}

                {modalType === 'deleteList' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Delete List Item</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Are you sure you want to delete this list item?</div>
                                <input type="text" defaultValue={modalListValue} className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full select-none" disabled />
                            </div>
                            <Button size='sm' text='DELETE' onClick={() => deleteModalData('list', modalIndex, modalListIndex)} />

                        </div>
                    </>
                )}

                {modalType === 'deleteListBlock' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Delete Block</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Are you sure you want to delete this list block?</div>
                            </div>
                            <Button size='sm' text='DELETE' onClick={() => deleteModalData('block')} />

                        </div>
                    </>
                )}

                {modalType === 'addTitleBlock' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Add Title Block</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Title</div>
                                <input type="text" ref={modalAddTitleBlock} defaultValue='' className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                            </div>
                            <Button size='sm' text='ADD' onClick={() => addModalDataBlock('addTitle', modalAddTitleBlock.current.value)} />

                        </div>
                    </>
                )}

                {modalType === 'editTitle' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Edit Title</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Title</div>
                                <input type="text" ref={modalEditTitle} defaultValue={modalValue} className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full" />
                            </div>
                            <Button size='sm' text='UPDATE' onClick={() => saveModalData(modalIndex, modalEditTitle.current.value)} />

                        </div>
                    </>
                )}

                {modalType === 'deleteTitle' && (
                    <>
                        <h2 className='flex justify-center xl:justify-start text-3xl text-kb-400 tracking-wide font-light'>Delete Title</h2>
                        <div className='space-y-6'>
                            <div className='space-y-2'>
                                <div className='font-bold'>Are you sure you want to delete this title?</div>
                                <input type="text" defaultValue={modalValue} className="bg-gray-50 border-1 border-kb-400/75 text-gray-900 text-sm rounded focus:ring-kb-300 focus:border-kb-300 block w-full select-none" disabled />
                            </div>
                            <Button size='sm' text='DELETE' onClick={() => deleteModalData('title', modalIndex)} />

                        </div>
                    </>
                )}

            </Modal>

        </>
    );
}
 
export default FabricsAdmin;
